import React, { useState } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import axios from "axios";
//MUI components
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
//custom components
import Footer from "../footer/footer";
import APIConfirmation from "./api-confirmation-dialog";

function AdminDashboard() {
  const [status, setStatus] = useState("NULL");
  const [secret, setSecret] = useState("1234");
  const navigate = useNavigate();
  //logout function
  const logout = () => {
    //log admin out
    //change the authentication to false before routing
    localStorage.setItem("isAuthenticated", false);
    navigate("/admin");
  };

  //insert team function
  function updateTeamNames(e) {
    axios
      .get(
        "https://dataxact-backend.vercel.app/teams/update-teamnames",
        {
          apiKey: 1234,
        },
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      )
      .then((response) => {
        setStatus(response.data);
        //response.data
      });
  }

  //update round1 score
  function updateRound1(e) {
    axios
      .put(
        "https://dataxact-backend.vercel.app/teams/update-round1",
        {
          apiKey: 1234,
        },
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      )
      .then((response) => {
        setStatus(response.data);
        //response.data
      });
  }

  //update round 2 score
  function updateRound2(e) {
    axios
      .put(
        "https://dataxact-backend.vercel.app/teams/update-round2",
        {
          apiKey: 1234,
        },
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      )
      .then((response) => {
        setStatus(response.data);
        //response.data
      });
  }
  //reset leaderboard
  function resetLeaderboard(e) {
    axios
      .post(
        "https://dataxact-backend.vercel.app/teams/reset-leaderboard",
        {
          apiKey: 1234,
        },
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      )
      .then((response) => {
        setStatus(response.data);
        //response.data
      });
  }

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }));
  return (
    <>
      {/*logo*/}
      <Box
        component="img"
        src="../../../dsc-logo.png"
        sx={{
          height: {
            xl: "6rem",
            lg: "5.5rem",
            md: "5rem",
            sm: "4.5rem",
            xs: "3rem",
          },
          marginTop: "2rem",
          display: "flex",
          marginLeft: "auto",
          marginRight: "auto",
          textAlign: "center",
          alignItems: "center",
        }}
      />
      {/*event title*/}
      <Typography
        sx={{
          lineHeight: "1.4",
          textAlign: "center",
          marginTop: "0.8rem",
          fontSize: {
            xl: "3rem",
            lg: "2.8rem",
            md: "2.5rem",
            sm: "2rem",
            xs: "1.3rem",
          },
          fontWeight: "bold",
          color: "#ffffff",
          letterSpacing: "0.3rem",
        }}
        variant="h1"
        gutterBottom
      >
        DataXact
      </Typography>
      {/*page title*/}
      <Typography
        sx={{
          textAlign: "center",
          fontSize: {
            xl: "2rem",
            lg: "1.8rem",
            md: "1.5rem",
            sm: "1.3rem",
            xs: "1rem",
          },
          color: "#ffffff",
          letterSpacing: "0.2rem",
          marginTop: "",
        }}
        variant="h2"
        gutterBottom
      >
        Admin Dashboard
      </Typography>
      {/*status bar*/}
      <Typography
        sx={{
          textAlign: "center",
          color: "#75FDC6",
          fontSize: "2rem",
          marginTop: "2rem",
        }}
      >
        Last Activity Status: {status}
      </Typography>
      {/*control buttons*/}
      <Stack
        direction={{
          xs: "column",
          sm: "column",
          md: "column",
          lg: "row",
          xl: "row",
        }}
        spacing={{ xs: 2, sm: 2, md: 4, lg: 6, xl: 6 }}
        display="flex"
        justifyContent="center"
        sx={{ position: "relative", top: "3rem" }}
      >
        <Button
          onClick={updateTeamNames}
          variant="outlined"
          sx={{
            color: "#ffffff",
            borderColor: "#ffffff",
            ":hover": { borderColor: "#4EFBD7", color: "#4EFBD7" },
          }}
        >
          Insert Teams
        </Button>
        <Button
          onClick={updateRound1}
          variant="outlined"
          sx={{
            color: "#ffffff",
            borderColor: "#ffffff",
            ":hover": { borderColor: "#4EFBD7", color: "#4EFBD7" },
          }}
        >
          Update Round-1 Score
        </Button>
        <Button
          onClick={updateRound2}
          variant="outlined"
          sx={{
            color: "#ffffff",
            borderColor: "#ffffff",
            ":hover": { borderColor: "#4EFBD7", color: "#4EFBD7" },
          }}
        >
          Update Round-2 Score
        </Button>
        <Button
          onClick={resetLeaderboard}
          variant="outlined"
          sx={{
            color: "#ffffff",
            borderColor: "#ffffff",
            ":hover": { borderColor: "#4EFBD7", color: "#4EFBD7" },
          }}
        >
          Reset Leaderboard
        </Button>
        <Button
          variant="outlined"
          sx={{
            color: "#ffffff",
            borderColor: "#ffffff",
            ":hover": { borderColor: "#4EFBD7", color: "#4EFBD7" },
          }}
        >
          Declare Winner
        </Button>
        <Button
          onClick={logout}
          variant="outlined"
          sx={{
            color: "#ffffff",
            borderColor: "#ffffff",
            ":hover": { borderColor: "#4EFBD7", color: "#4EFBD7" },
          }}
        >
          Logout
        </Button>
      </Stack>
      <br></br>
      <Footer upload="false" sx={{ marginTop: "2rem" }}></Footer>
    </>
  );
}
export default AdminDashboard;
